import { memo } from 'react';
import { Check, Clock, Inbox, PhoneMissed, X } from 'lucide-react';
import type { DealRowModel } from '@/lib/pipelineQuery';
import { plural } from '@/lib/pipelineQuery';

interface Props {
  id: string;
  model: DealRowModel;
  busy?: boolean;
  onOpen: (id: string) => void;
  onAccept?: (id: string) => void;
  onReject?: (id: string) => void;
}

/**
 * Строка сделки (прототип, pipeScreen → .drow): точка стадии, компания/имя, сумма; подпись; сигналы —
 * пропущенные звонки (красным), «ждёт ответа» (акцентом), ближайшая задача (красным, если просрочена).
 * У лида в «Новых» — «Принять» и «Отсеять» прямо в строке.
 */
export const DealRow = memo(function DealRow({ id, model: m, busy, onOpen, onAccept, onReject }: Props) {
  const signals = m.missed > 0 || m.awaiting || m.task;
  return (
    <div className="drow-wrap">
      <button type="button" className="drow" onClick={() => onOpen(id)}>
        <span className="l1">
          <span className="sdot" style={{ background: m.stageColor }} aria-hidden />
          <b>{m.title}</b>
          <span className="amt tnum">{m.amountText}</span>
        </span>
        {m.subtitle && <span className="rt">{m.subtitle}</span>}
        {signals && (
          <span className="sig">
            {m.missed > 0 && (
              <span className="red"><PhoneMissed aria-hidden />{m.missed} {plural(m.missed, 'пропущенный', 'пропущенных', 'пропущенных')}</span>
            )}
            {m.awaiting && <span className="acc"><Inbox aria-hidden />ждёт ответа</span>}
            {m.task && <span className={m.task.late ? 'red' : 'mut'}><Clock aria-hidden />{m.task.text}</span>}
          </span>
        )}
      </button>
      {m.isLead && onAccept && onReject && (
        <div className="acts">
          <button type="button" className="pri" disabled={busy} onClick={() => onAccept(id)} aria-label={`Принять «${m.title}»`}>
            <Check aria-hidden />Принять
          </button>
          <button type="button" disabled={busy} onClick={() => onReject(id)} aria-label={`Отсеять «${m.title}»`}>
            <X aria-hidden />Отсеять
          </button>
        </div>
      )}
    </div>
  );
});
